import { IUserActivityGroupBy } from 'graphql/types';

const MAX_DAYS_FOR_QUARTER_HOUR = 1;
const MAX_DAYS_FOR_HOURLY = 3;
const MAX_DAYS_FOR_DAILY = 90;
const MIN_DAYS_FOR_DAILY = 1;
const MIN_DAYS_FOR_MONTHLY = 28;

/** Checks if a groupBy option is valid for a given date range (in days). */
export const isGroupByValidForRange = (
    groupBy: IUserActivityGroupBy,
    daysDiff: number
): boolean => {
    switch (groupBy) {
        case IUserActivityGroupBy.QuarterHour:
            return daysDiff <= MAX_DAYS_FOR_QUARTER_HOUR;
        case IUserActivityGroupBy.Hour:
            return daysDiff <= MAX_DAYS_FOR_HOURLY;
        case IUserActivityGroupBy.Day:
            return (
                daysDiff > MIN_DAYS_FOR_DAILY && daysDiff <= MAX_DAYS_FOR_DAILY
            );
        case IUserActivityGroupBy.Month:
            return daysDiff > MIN_DAYS_FOR_MONTHLY;
        default:
            return false;
    }
};

/** Returns the default groupBy fallback for a date range. QuarterHour is excluded (manual only). */
export const getGroupByForRange = (daysDiff: number): IUserActivityGroupBy => {
    if (daysDiff <= MAX_DAYS_FOR_HOURLY) return IUserActivityGroupBy.Hour;
    if (daysDiff <= MAX_DAYS_FOR_DAILY) return IUserActivityGroupBy.Day;

    return IUserActivityGroupBy.Month;
};
